/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { FaBars, FaCashRegister, FaCheck, FaLockOpen, FaProductHunt, FaUserAlt, FaWindowClose } from "react-icons/fa";
import { CiMoneyBill, CiViewList } from "react-icons/ci";
import { BiGroup } from "react-icons/bi";
import { IoExitOutline, IoTicketOutline } from "react-icons/io5";
import { RiCustomerServiceLine, RiUserStarLine } from "react-icons/ri";
import { AiOutlineSetting } from "react-icons/ai";
import { GrLink } from "react-icons/gr";

import {
  HiLockClosed,
  HiOutlineHome,
  HiOutlineDocumentReport,
} from "react-icons/hi";
import {
  MdOutlineSportsMotorsports,
  MdOutlineDeliveryDining,
  MdCampaign,
} from "react-icons/md";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useContext, useEffect, useState } from "react";
import { useDistrict } from "../../hooks/useDistrict";
import { useCompany } from "../../hooks/useCompany";
import { isMobile } from "react-device-detect";
import { api } from "../../api/api";
import { Toast } from "../../utils/Toast";
import { MercadoPago } from "../Modals/MercadoPago";
import { BsArrowsFullscreen, BsBag, BsFillInboxesFill, BsDisplay } from "react-icons/bs";
import { loadGMaps } from "../../utils/loadMaps";
import { useIntegrationWhatsApp } from "../../hooks/useIntegrationWhatsApp";
import { Wpp } from "../Modals/Wpp";
import { CLEAR_SELECT_ORDER } from "../../stores/reducers/OrderReducers";
import { LuStickyNote } from "react-icons/lu";
import { GlobalContext } from "../../context/GlobalContext";
import { iOS } from '../../utils/utils'
import { FiChevronDown } from "react-icons/fi";
import './style.css'

function SidebarGroup({ label, icon, active, children }) {
  const [open, setOpen] = useState(active);

  useEffect(() => {
    if (active) setOpen(true);
  }, [active]);

  return (
    <div className={`sidebar-nav-group ${open ? "open" : ""}`}>
      <button
        type="button"
        className={`nav-link sidebar-nav-group-toggle ${active ? "active" : ""}`}
        onClick={() => setOpen((current) => !current)}
        aria-expanded={open}
      >
        <div className="sb-nav-link-icon">{icon}</div>
        <span>{label}</span>
        <FiChevronDown className="sidebar-nav-group-arrow" />
      </button>
      {open && <div className="sidebar-nav-group-items">{children}</div>}
    </div>
  );
}

export function NavBar({ children }) {
  const { isAccess } = useContext(GlobalContext);
  const natigate = useNavigate();
  const location = useLocation();
  const { updatedComapny, companyPlan } = useCompany();
  const { checkWpp } = useIntegrationWhatsApp();

  const company = useSelector((state) => state.company.data);
  const dispatch = useDispatch();

  const { districts, loadDeliveryDistrict } = useDistrict();
  const { load, sectors, loadSectors, loadConfiguration, configurations } =
    useCompany();

  const [wppStatus, setWppStatus] = useState("Conectando...");
  const [companyStatus, setCompanyStatus] = useState(null);

  const getNavLinkClass = (path) =>
    `nav-link ${location.pathname === path ? "active" : ""}`;

  const hasAccess = (key, permission = "view") =>
    [true, "admin"].includes(isAccess(key, permission));

  const menuGroups = [
    {
      label: "Operação",
      icon: <FaCashRegister color="white" size={18} />,
      items: [
        hasAccess("caixa") && { path: "/safe", label: "Caixa", icon: <FaCashRegister size={17} /> },
        hasAccess("kds") && { path: "/kds", label: "KDS / Cozinha", icon: <BsDisplay size={17} /> },
      ].filter(Boolean),
    },
    {
      label: "Produtos e estoque",
      icon: <FaProductHunt color="white" size={18} />,
      items: [
        hasAccess("produtos") && { path: "/product", label: "Produtos", icon: <FaProductHunt size={17} /> },
        hasAccess("estoque") && { path: "/stock", label: "Estoque", icon: <BsFillInboxesFill size={17} /> },
        hasAccess("setor") && { path: "/sectors", label: "Setores", icon: <BsArrowsFullscreen size={17} /> },
      ].filter(Boolean),
    },
    {
      label: "Aumente as vendas",
      icon: <MdCampaign color="white" size={18} />,
      items: [
        hasAccess("relatorio") && { path: "/report", label: "Relatórios", icon: <HiOutlineDocumentReport size={17} /> },
        hasAccess("campanha") && { path: "/campanha", label: "Campanhas", icon: <MdCampaign size={17} /> },
        hasAccess("cardapio") && { path: "/cross-selling", label: "Venda cruzada", icon: <BsBag size={17} /> },
      ].filter(Boolean),
    },
    {
      label: "Captura de clientes",
      icon: <RiCustomerServiceLine color="white" size={18} />,
      items: [
        hasAccess("clientes") && { path: "/customer", label: "Clientes", icon: <BiGroup size={17} /> },
        hasAccess("cupons") && { path: "/cupom", label: "Cupons de desconto", icon: <IoTicketOutline size={17} /> },
        hasAccess("avaliacao") && { path: "/rating", label: "Avaliações", icon: <RiUserStarLine size={17} /> },
      ].filter(Boolean),
    },
    {
      label: "Entregas",
      icon: <MdOutlineDeliveryDining color="white" size={18} />,
      items: [
        hasAccess("entregadores") && { path: "/motoboy", label: "Entregadores", icon: <MdOutlineSportsMotorsports size={17} /> },
        hasAccess("metodo_entrega") && { path: "/method-delivery", label: "Métodos de entrega", icon: <MdOutlineDeliveryDining size={17} /> },
      ].filter(Boolean),
    },
    {
      label: "Gestão",
      icon: <AiOutlineSetting color="white" size={18} />,
      items: [
        hasAccess("fiscal") && { path: "/fiscal", label: "Fiscal", icon: <LuStickyNote size={17} /> },
        hasAccess("forma_pagamento") && { path: "/payment-method", label: "Formas de pagamento", icon: <CiMoneyBill size={17} /> },
      ].filter(Boolean),
    },
  ].filter((group) => group.items.length > 0);

  const directMenuLinks = [
    hasAccess("configuracoes") && { path: "/company", label: "Meus dados", icon: <AiOutlineSetting size={18} /> },
    hasAccess("integracao") && { path: "/integration", label: "Integrações", icon: <GrLink size={18} /> },
    hasAccess("user") && { path: "/users", label: "Usuários", icon: <FaUserAlt size={18} /> },
  ].filter(Boolean);

  function logout() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    natigate("/");
  }

  useEffect(() => {
    if (!company.id) load();

    if (!configurations.id) {
      loadConfiguration();
    }

    if (districts.length === 0) loadDeliveryDistrict();

    if (sectors.length === 0) {
      loadSectors();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (configurations.id) {
      loadGMaps(() => { }, configurations.googleKey);
    }
  }, [configurations.googleKey, configurations.id]);

  async function paused(paused = null, minute) {
    await api.post("/companies/paused", {
      minutes: minute,
      paused: paused,
    });

    updatedComapny({
      paused: paused === "open" ? false : true,
    });

    if (paused === "open") {
      setCompanyStatus("Loja aberta");
      return Toast.success("Registro salvo com sucesso.");
    }

    if (paused !== null) {
      setCompanyStatus("Loja fechada");
      return Toast.success("Registro salvo com sucesso.");
    }

    setCompanyStatus("Loja fechada");
    return Toast.success(`Loja ficará pausada durante ${minute}.`);
  }

  useEffect(() => {
    setTimeout(async () => {
      const result = await checkWpp();
      if (result) {
        setWppStatus("Conectado");
      } else {
        setWppStatus("Desconectado");
      }
    }, 3000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    (async () => {
      const { status } = await api.get(
        "companies/company/schedules/close/or/open"
      );
      if (status === 204) {
        setCompanyStatus("Loja aberta");
      } else {
        setCompanyStatus("Loja fechada");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function clear() {
    isMobile && document.body.classList.toggle("sb-sidenav-toggled");
    dispatch(CLEAR_SELECT_ORDER());
  }

  useEffect(() => {
    if (!configurations.idStore) {
      return;
    }

    if (isAccess() === "garcom") {
      return;
    }

    if (!iOS()) {
      window.iFoodWidget.init({
        widgetId: "dddb6875-1458-4db2-b0c6-783b3a129ab7",
        merchantIds: [configurations.idStore],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configurations.idStore]);

  useEffect(() => {
    if (window.location.pathname !== '/' && window.location.pathname !== '/register') {
      companyPlan()
    }
  }, [])

  return (
    <>
      {isAccess() !== "garcom" && (
        <>
          <MercadoPago />
          <Wpp status={wppStatus} />
          <nav className="sb-topnav navbar navbar-expand navbar-dark bg-dark-blue-1">
            <Link
              className="topnav-brand"
              to="/home"
            >
              <img src="./banner-sem-fundo.png" style={{ width: '165px!important' }} alt="Unledu Pedidos" />
            </Link>
            <button
              type="button"
              className="topnav-menu-button order-1 order-lg-0 ms-auto ms-md-0"
              onClick={() =>
                document.body.classList.toggle("sb-sidenav-toggled")
              }
              aria-label="Abrir ou fechar menu lateral"
            >
              <FaBars />
            </button>

            {window.screen.width > 765 && (
              <>

                <button type="button" className={`topnav-status-pill whatsapp-status ${wppStatus === 'Conectado' ? 'connected' : wppStatus === 'Desconectado' ? 'disconnected' : 'loading'}`} onClick={() => {
                  window.location.href = '/integration'
                }} title="Abrir configurações do WhatsApp">
                  <img
                    src="https://cardapio.unledu.com.br/wpp-logo.png"
                    alt="WhatsApp"
                    width={'20px'}
                  />
                  <span className="topnav-status-copy">
                    <small>WhatsApp</small>
                    <strong>{wppStatus}</strong>
                  </span>
                  {wppStatus === 'Desconectado' ? <FaWindowClose /> : wppStatus === 'Conectado' ? <FaCheck /> : <span className="topnav-status-dot" />}
                </button>


                {companyStatus !== null && (
                  <button type="button" className={`topnav-status-pill ${companyStatus === 'Loja aberta' ? 'connected' : 'disconnected'}`} onClick={() => {
                    window.location.href = '/company'
                  }} title="Abrir configurações da loja">
                    {companyStatus === 'Loja aberta' ? <FaLockOpen /> : <HiLockClosed />}
                    <span className="topnav-status-copy">
                      <small>Status da loja</small>
                      <strong>{companyStatus === 'Loja aberta' ? 'Aberta' : 'Fechada'}</strong>
                    </span>
                    <span className="topnav-status-dot" />
                  </button>
                )}

                {companyStatus === null && (
                  <div className="topnav-status-pill loading" role="status">
                    <span className="spinner-border spinner-border-sm" />
                    <span className="topnav-status-copy"><small>Status da loja</small><strong>Verificando</strong></span>
                  </div>
                )}

                <div className="navbar-store-actions d-none d-md-flex ms-auto me-3">
                  <button
                    type="button"
                    className="topnav-store-button"
                    onClick={() => {
                      if (company.domain) {
                        window.open(`https://${company.domain}`, "_blank");
                      } else {
                        window.open(
                          `${process.env.REACT_APP_CARDAPIO}/${company.link}`,
                          "_blank"
                        );
                      }
                    }}
                  >
                    <CiViewList size={18} /> <span>Acessar cardápio</span>
                  </button>
                  <div className="dropdown dropstart">
                    <button
                      className="topnav-store-button topnav-store-button-danger dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <HiLockClosed size={17} /> <span>Fechar / Pausar loja</span>
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li>
                        <a
                          className="dropdown-item pointer"
                          onClick={() => paused("close", 1)}
                        >
                          Fechar até o próximo dia
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item pointer"
                          onClick={() => paused("open", 1)}
                        >
                          Abrir loja
                        </a>
                      </li>
                      <div className="divider"></div>
                      <li>
                        <a
                          className="dropdown-item pointer"
                          onClick={() => paused(null, 15)}
                        >
                          15 minutos
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item pointer"
                          onClick={() => paused(null, 30)}
                        >
                          30 minutos
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item pointer"
                          onClick={() => paused(null, 45)}
                        >
                          45 minutos
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item pointer"
                          onClick={() => paused(null, 60)}
                        >
                          1 horas
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item pointer"
                          onClick={() => paused(null, 120)}
                        >
                          2 horas
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item pointer"
                          onClick={() => paused(null, 180)}
                        >
                          3 horas
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item pointer"
                          onClick={() => paused(null, 360)}
                        >
                          6 horas
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item pointer"
                          onClick={() => paused(null, 720)}
                        >
                          12 horas
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </>
            )}
          </nav>
          <div id="layoutSidenav" style={{}}>
            <div id="layoutSidenav_nav">
              <nav
                className="sb-sidenav accordion sb-sidenav-dark"
                id="sidenavAccordion"
                style={{ overflowY: "auto", overflowX: "hidden", maxHeight: "calc(100vh - 70px)" }}
              >
                <div className="sb-sidenav-menu">
                  <div className="nav">
                    <Link
                      className={getNavLinkClass("/home")}
                      to="/home"
                      onClick={() => clear()}
                    >
                      <div className="sb-nav-link-icon">
                        <HiOutlineHome color="white" size={18} />
                      </div>
                      Inicio
                    </Link>

                    {hasAccess("cardapio") && (
                      <Link
                        className={getNavLinkClass("/menu")}
                        to="/menu"
                        onClick={() => clear()}
                      >
                        <div className="sb-nav-link-icon">
                          <CiViewList color="white" size={18} />
                        </div>
                        Cardápio
                      </Link>
                    )}

                    {menuGroups.map((group) => (
                      <SidebarGroup
                        key={group.label}
                        label={group.label}
                        icon={group.icon}
                        active={group.items.some((item) => item.path === location.pathname)}
                      >
                        {group.items.map((item) => (
                          <Link
                            key={item.path}
                            className={getNavLinkClass(item.path)}
                            to={item.path}
                            onClick={() => clear()}
                          >
                            <div className="sb-nav-link-icon">{item.icon}</div>
                            {item.label}
                          </Link>
                        ))}
                      </SidebarGroup>
                    ))}

                    {directMenuLinks.map((item) => (
                      <Link
                        key={item.path}
                        className={getNavLinkClass(item.path)}
                        to={item.path}
                        onClick={() => clear()}
                      >
                        <div className="sb-nav-link-icon">{item.icon}</div>
                        {item.label}
                      </Link>
                    ))}
                    {window.screen.width < 765 && (
                      <>
                        <Link
                          className="nav-link"
                          onClick={() => {
                            if (company.domain) {
                              window.open(
                                `https://${company.domain}`,
                                "_blank"
                              );
                            } else {
                              window.open(
                                `${process.env.REACT_APP_CARDAPIO}/${company.link}`,
                                "_blank"
                              );
                            }
                          }}
                        >
                          <div className="sb-nav-link-icon">
                            <CiViewList color="white" size={18} />
                          </div>
                          Acessar Cardápio
                        </Link>

                        <Link className="nav-link" onClick={() => clear()}>
                          <div className="sb-nav-link-icon">
                            <HiLockClosed color="white" size={18} />
                          </div>
                          <div className="dropdown d-md-inline-block">
                            <button
                              className="btn btn-sm text-white dropdown-toggle"
                              type="button"
                              id="dropdownMenuButton1"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              Fechar / Pausar loja
                            </button>
                            <ul
                              className="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a
                                  className="dropdown-item pointer"
                                  onClick={() => paused(false, null)}
                                >
                                  Abrir loja
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item pointer"
                                  onClick={() => paused(true, null)}
                                >
                                  Fechar loja
                                </a>
                              </li>
                              <div className="divider"></div>
                              <li>
                                <a
                                  className="dropdown-item pointer"
                                  onClick={() => paused(null, 15)}
                                >
                                  15 minutos
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item pointer"
                                  onClick={() => paused(null, 30)}
                                >
                                  30 minutos
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item pointer"
                                  onClick={() => paused(null, 45)}
                                >
                                  45 minutos
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item pointer"
                                  onClick={() => paused(null, 60)}
                                >
                                  1 hora
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item pointer"
                                  onClick={() => paused(null, 120)}
                                >
                                  2 hora
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item pointer"
                                  onClick={() => paused(null, 180)}
                                >
                                  3 hora
                                </a>
                              </li>
                            </ul>
                          </div>
                        </Link>
                      </>
                    )}
                  </div>
                </div>
                <div>
                  <div
                    style={{ textAlign: "left!important", fontSize: "1rem" }}
                    className="text-start"
                  >
                    <hr className="mb-0 mt-0" />
                    {/* <button
                      className="btn btn-sm text-white p-2 mb-2 mt-2 text-start w-100 "
                      data-bs-toggle="modal"
                      data-bs-target="#mercadoPagoPlanos"
                      style={{ border: 'none' }}
                    >
                      <BsBag size={18} className="mb-1" /> Meu plano
                    </button> */}
                    <button
                      onClick={() =>
                        window.open(
                          "https://api.whatsapp.com/send?phone=5531989554735",
                          "_blank"
                        )
                      }
                      className="btn btn-sm text-white p-2 mb-2 mt-2 w-100 text-start"
                      style={{ border: 'none' }}
                    >
                      <RiCustomerServiceLine size={18} /> Suporte
                    </button>
                  </div>
                  <hr className="mb-0 mt-0" />
                  <div className="text-start">
                    <button
                      className="border rounded btn btn-sm mt-2 text-white w-100 text-start "
                      style={{ fontSize: "1rem", border: 'none' }}
                      onClick={() => logout()}
                    >
                      {" "}
                      <IoExitOutline /> Sair
                    </button>
                  </div>
                </div>
              </nav>
            </div>
            <div
              id="layoutSidenav_content"
              className="elementoteste"
              style={{ height: "calc(100vh -100px)", overflow: "auto" }}
            >
              {children}
            </div>
          </div>
        </>
      )}

      {isAccess() === "garcom" && (
        <div style={{ width: "100%" }}>
          <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
            <div className="container-fluid">
              <a className="navbar-brand" href="#">
                Unledu Pedidos
              </a>
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav me-auto mb-2 mb-lg-0"></ul>
                <div className="d-flex">
                  <button
                    className="btn border text-white btn-sm"
                    onClick={() => logout()}
                  >
                    Deslogar
                  </button>
                </div>
              </div>
            </div>
          </nav>
          {children}
        </div>
      )}
    </>
  );
}
